import AppStoreModule from '@revas/kadra-library/src/core/app/vue/vuex/AppStoreModule'
import { Client as RevasClient } from '@revas/ts-api'

export default class CoreStoreModuleContainer {
  appStoreModule: AppStoreModule
  revasClient: RevasClient

  public constructor (appStoreModule: AppStoreModule, revasClient: RevasClient) {
    this.appStoreModule = appStoreModule
    this.revasClient = revasClient
  }
}
